import "./assets/main.min.css";
import { createApp as o } from "vue";
import t from "./App.vue";
import s from "./router/index.min.js";
import r from "./i18n/index";
import i from "./i18n/locales/en.json";
import e from "./i18n/locales/ar.json";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "animate.css";
import p from "./Store/index";
import m from "vuex";
import "./Store/subscriber";
import a from "axios";
a.defaults.baseURL = "https://app.trustksaa.com/api/v1/";
import n from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./utils/reveal.js";
import u from "./utils/toastOptions";
import "./utils/LangMounted";
export default { en: i, ar: e };
import c from "vue3-google-login";
let CLIENT_ID =
  "820539129450-3m2uqrr7ub372q33oskt361nddo4bops.apps.googleusercontent.com";
import l from "js-cookie";
p.dispatch("auth/attempt", l.get("jwt")).then(() => {
  p.dispatch("fetchGeneralSettings").then(() => {
    let i = o(t);
    i.use(s),
      i.use(p),
      i.use(n, u),
      i.use(m),
      i.use(r),
      i.use(c, {
        clientId:
          "820539129450-3m2uqrr7ub372q33oskt361nddo4bops.apps.googleusercontent.com",
      }),
      i.mount("#app"),
      document.querySelector(".preloader").classList.add("d-none");
  });
});
